// @flow
import React from 'react';
import {Chip} from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

import {colors} from '../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  root: {
    background: '#F5F0FF',
    marginLeft: 10,
    fontWeight: 600,
    '& span': {
      fontSize: '0.875rem',
      color: colors.purple3,
    },
  },
}));

export default function NewFeatureBadge() {
  const classes = useStyles();

  return <Chip label="NUEVO" size="small" className={classes.root} />;
}

NewFeatureBadge.propTypes = {};
